/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDataCounter.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const setDataCounter = () => {
    let slideLength = document.querySelectorAll(".slider__list-item").length.toString();
    let docDataPosCounter = document.querySelector(".data-pos-counter");
    let dataNum = document.querySelectorAll("[data-num]");
    let circle1 = document.querySelector(".circle1");
    let intervalTime = 6000;
    function setDataPosCounter() {
        let dataPos = docDataPosCounter.dataset.position;
        dataPos === slideLength ? docDataPosCounter.dataset.position = "1" : docDataPosCounter.dataset.position++;
        dataNum.forEach(function (item) {
            item.dataset.num === docDataPosCounter.dataset.position ? item.classList.add("--active") : item.classList.remove("--active");
        });
    }

    function circle1Animation() {
        gsap.to(circle1, {
            keyframes: [
                { strokeDashoffset: `${circle1.clientWidth}`, duration: 6, ease: "linear", },
                { strokeDashoffset: 155, duration: 0, ease: "none", }
            ],
        })
    }

    setDataPosCounter();
    circle1Animation();
    
    window.setInterval(() => {
        setDataPosCounter();
        circle1Animation();
    }, intervalTime);
};

export {
    setDataCounter
}